"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

module.exports = function LinkStyleImpl() {
  _classCallCheck(this, LinkStyleImpl);
};